import { render } from "./LeadStatus.vue?vue&type=template&id=76451240&scoped=true"
import script from "./LeadStatus.vue?vue&type=script&lang=js"
export * from "./LeadStatus.vue?vue&type=script&lang=js"

import "./LeadStatus.vue?vue&type=style&index=0&id=76451240&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-76451240"

export default script